"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailLocationsHandler = void 0;
// external
const React = require("react");
const react_1 = require("react");
// local
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const useSyncedData_1 = require("../../../../../hooks/useSyncedData");
const useClient_1 = require("../../../../../hooks/useClient");
/**
 * Provide the retail location list and the current active retail location.
 */
const RetailLocationsHandler = ({ retailLocationSlug, children }) => {
    const client = (0, useClient_1.useClient)();
    const [retailLocation, setRetailLocation] = (0, react_1.useState)(undefined);
    const [requestedRetailLocationSlug, setRequestedRetailLocationSlug] = (0, react_1.useState)(retailLocationSlug);
    const retailLocations = (0, useSyncedData_1.useSyncedData)(client.retailLocations.retrieveSyncedRetailLocations());
    // indicate that the retail location is available
    (0, react_1.useEffect)(() => {
        if (retailLocation === undefined && !!retailLocations) {
            // allow others to know we can be set
            setRetailLocation(null);
        }
    }, [retailLocations]);
    (0, react_1.useEffect)(() => {
        if (!requestedRetailLocationSlug || !retailLocations) {
            return;
        }
        // HACK - work around for inconsistent identifiers
        const l = retailLocations.find((loc) => loc.slug === requestedRetailLocationSlug);
        if (!l) {
            console.warn(`Unknown retail location ${requestedRetailLocationSlug}`);
            return;
        }
        setRetailLocation(l);
    }, [requestedRetailLocationSlug, retailLocations]);
    const clearLocation = (0, react_1.useCallback)(() => {
        setRetailLocation(null);
    }, []);
    const provider = (0, react_1.useMemo)(() => {
        return {
            retailLocations,
            retailLocation,
            requestedRetailLocationSlug,
            setRetailLocation,
            setRequestedRetailLocationSlug,
            clearLocation
        };
    }, [
        retailLocations,
        retailLocation,
        requestedRetailLocationSlug,
        setRetailLocation,
        setRequestedRetailLocationSlug,
        clearLocation
    ]);
    return (React.createElement(RetailLocationsContext_1.RetailLocationsContext.Provider, { value: provider }, children));
};
exports.RetailLocationsHandler = RetailLocationsHandler;
//# sourceMappingURL=index.js.map